(() => {
  if (window.__SKW_FAST_SHOP__) return;
  window.__SKW_FAST_SHOP__ = true;

  const guarded = new Set([
    'grosse-kerze-natur-mit-wunschtext-zu-weihnachten',
    'grosse-kerze-countdown-mit-namen-wunschtext-zu-weihnachten',
    'grosse-kerze-ho-ho-ho-bedruckt-mit-namen-zu-weihnachten',
    'grosse-kerze-rentier-bedruckt-mit-namen-zu-weihnachten',
    'grosse-kerze-classic-merry-xmas-mit-namen-zu-weihnachten',
    'grosse-kerze-eisbar-pinguin-mit-namen-zu-weihnachten',
    'grosse-kerze-eisbar-mit-namen-zu-weihnachten',
    'osterkerze-osterlamm-name',
    'osterkerze-alpha-omega-wunschtext',
    'teelichthalter-set-namensherz-mama-personalisiert',
    'muttertagskerze-glueck-ist-eine-mama-wunschtext',
    'personalisierte-halloween-kerze-gruselschloss',
    'halloween-kerze-tanzende-skelette-mit-name',
    'halloween-kerze-hexentrank-mit-name',
    'halloween-kerze-kopfloser-reiter-mit-name',
    'halloween-kerze-regenbogen-mit-name',
    'halloween-kerze-rabe-mit-name',
    'halloween-kerze-skelett-party-mit-name',
    'halloween-kerze-musiker-skelett-mit-name',
    'halloween-kerze-fledermaus-mit-name',
    'personalisierte-kerze-name-schriften-farben',
    'grosse-kerze-adventszauber-mit-namen-zu-weihnachten',
    'grosse-kerze-gluhwein-elch-zu-weihnachten',
    'grosse-kerze-christmas-love-mit-namen-zu-weihnachten',
    'grosse-kerze-frohliche-weihnachten-haus-zu-weihnachten',
    'hochzeitskerze-pampasgras-love-klein-namen-datum',
    'led-flaschenlicht-beste-freundin-wunschkonfiguration',
    'hochzeitskerze-tropical-pampasgras-klein-namen-datum',
    'hochzeitskerze-pampasgras-love-name-datum',
    'led-flaschenlicht-paerchen-wunschkonfiguration',
    'hochzeitskerze-tropical-pampasgras-gross-namen-datum',
    'teelichthalter-set-hand-in-hand-name-datum',
    'grosse-kerze-engel-schwalbe-bedruckt-mit-wunschtext-zu-weihnachten',
    'grosse-kerze-tannenbaum-bedruckt-mit-namen-wunschtext-zu-weihnachten',
    'grosse-kerze-christmas-stars-bedruckt-mit-namen-wunschtext-zu-weihnachten',
    'grosse-kerze-christmas-ornament-bedruckt-mit-namen-wunschtext-zu-weihnachten',
    'flaschenlicht-mit-led-lichterkette-und-uv-druck-weihnachtskugeln-design-personalisiert-mit-name',
    'flaschenlicht-mit-led-lichterkette-im-frohe-weihnachten-mama-design-personalisiert-mit-namen',
    'flaschenlicht-mit-led-lichterkette-im-frohe-weihnachten-design-personalisiert-mit-2-namen',
    'flaschenlicht-mit-led-lichterkette-im-hallo-winter-design-personalisiert-mit-namen',
    'flaschenlicht-mit-led-lichterkette-im-frohliche-weihnachten-santa-design-personalisiert-mit-namen',
    'flaschenlicht-mit-led-lichterkette-und-uv-druck-hirsch-design-personalisiert-mit-name',
    'flaschenlicht-mit-led-lichterkette-und-uv-druck-pinguine-design-personalisiert-mit-name',
    'flaschenlicht-mit-led-lichterkette-und-uv-druck-weihnachtsbaum-gold-design-personalisiert',
    'flaschenlicht-mit-led-lichterkette-und-uv-druck-weihnachtskreis-vogel-design-personalisiert',
    'personalisierter-adventskalender-aus-holz-mit-druckmotiv-namen-waldtiere',
    'taufkerze-arche-regenbogen-name-datum-wunschtext',
    'taufkerze-fische-bunt-name-datum-wunschtext',
    'personalisierter-adventskalender-aus-holz-mit-druckmotiv-namen-nordpol'
  ]);

  const lang = (document.documentElement.lang || 'de').toLowerCase();
  const personalizeLabel = lang.startsWith('nl') ? 'Personaliseren' : lang.startsWith('en') ? 'Customize' : lang.startsWith('fr') ? 'Personnaliser' : lang.startsWith('tr') ? 'Kişiselleştir' : 'Personalisieren';

  const handleFrom = href => {
    try {
      const url = new URL(href, location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (_) { return ''; }
  };

  const apply = () => {
    document.querySelectorAll('.product-card-wrapper').forEach(card => {
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      const handle = handleFrom(productLink.getAttribute('href'));
      const quick = card.querySelector('.quick-add');
      if (!quick) return;

      if (guarded.has(handle)) {
        if (quick.dataset.skwGuarded === '1') return;
        const href = productLink.href;
        quick.innerHTML = '';
        const link = document.createElement('a');
        link.href = href;
        link.className = 'quick-add__submit button button--full-width button--primary';
        link.textContent = personalizeLabel;
        link.setAttribute('aria-label', personalizeLabel + ': ' + (card.querySelector('.card__heading')?.textContent || '').trim());
        quick.appendChild(link);
        quick.dataset.skwGuarded = '1';
        return;
      }

      quick.querySelectorAll('.quick-add__submit').forEach(button => {
        button.classList.remove('button--secondary');
        button.classList.add('button--primary');
      });
    });
  };

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; apply(); });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', apply, { once: true }) : apply();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();